<template>
  <div class="sidebar" :class="{ active: showSidebar }">
    <b-img class="mb-3 sidebar-logo" :src="logo" />
    <!-- scrollbar bonita -->
    <b-tabs>
      <b-tab title="Atuais">
        <vue-custom-scrollbar class="scroll-area">
          <div class="sidebar-menu">
            <FeathersVuexFind
              service="orders"
              :query="{
                ...searchQuery,
              }"
              local
            >
              <div slot-scope="props">
                <div
                  v-for="order in orders(props.items)"
                  :key="order._id"
                  class="sidebar-item"
                >
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      order.totemClientName ||
                      order.noAuthName ||
                      user(order.customer)
                    "
                    :class="`sidebar-link ${
                      order._id === selectedOrder ? 'active' : ''
                    }`"
                    @click="set(order._id)"
                  >
                    <img
                      :src="photo(user(order.customer, order.totemClientName))"
                      alt="foto de perfil de usuario"
                      class="user-photo mr-2"
                    />
                    <div class="user-info">
                      <p class="user-name">
                        {{
                          order.totemClientName ||
                          order.noAuthName ||
                          user(order.customer).name.split(" ")[0]
                        }}
                      </p>
                      <p class="order-status">
                        #{{ order.seq }}
                        <b-badge :class="statusClass(order.status)">
                          {{ translateStatus(order.status) }}
                        </b-badge>
                      </p>
                      <p>{{ howLong(order.createdAt) }}</p>
                    </div>
                  </div>
                  <div
                    v-else
                    :class="`sidebar-link ${
                      order._id === selectedOrder ? 'active' : ''
                    } d-flex align-items-center`"
                    @click="set(order._id)"
                  >
                    <div
                      class="user-photo mr-2 spinner-border text-black"
                    ></div>
                    <div class="user-info">
                      <p class="user-name">Procurando usuário...</p>
                      <p class="order-status">
                        #{{ order.seq }}
                        <b-badge :class="statusClass(order.status)">
                          {{ translateStatus(order.status) }}
                        </b-badge>
                      </p>
                      <p>{{ howLong(order.createdAt) }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </FeathersVuexFind>
          </div>
        </vue-custom-scrollbar>
      </b-tab>
      <b-tab
        title="Agendados"
        v-if="branch.scheduling && branch.scheduling.active"
      >
        <vue-custom-scrollbar class="scroll-area">
          <div class="sidebar-menu">
            <FeathersVuexFind service="orders" :query="queryScheduled" local>
              <div slot-scope="props">
                <div
                  v-for="order in ordersScheduled(props.items)"
                  :key="order._id"
                  class="sidebar-item"
                >
                  <div
                    class="d-flex align-items-center"
                    v-if="
                      order.totemClientName ||
                      order.noAuthName ||
                      user(order.customer)
                    "
                    :class="`sidebar-link ${
                      order._id === selectedOrder ? 'active' : ''
                    }`"
                    @click="set(order._id)"
                  >
                    <img
                      :src="photo(user(order.customer, order.totemClientName))"
                      alt="foto de perfil de usuario"
                      class="user-photo mr-2"
                    />
                    <div class="user-info">
                      <p class="user-name">
                        {{
                          order.totemClientName ||
                          order.noAuthName ||
                          user(order.customer).name.split(" ")[0]
                        }}
                      </p>
                      <p class="order-status">
                        #{{ order.seq }}
                        <b-badge :class="statusClass(order.status)">
                          {{ translateStatus(order.status) }}
                        </b-badge>
                      </p>
                      <p>{{ howLong(order.createdAt) }}</p>
                    </div>
                  </div>
                  <div
                    v-else
                    :class="`sidebar-link ${
                      order._id === selectedOrder ? 'active' : ''
                    } d-flex align-items-center`"
                    @click="set(order._id)"
                  >
                    <div
                      class="user-photo mr-2 spinner-border text-black"
                    ></div>
                    <div class="user-info">
                      <p class="user-name">Procurando usuário...</p>
                      <p class="order-status">
                        #{{ order.seq }}
                        <b-badge :class="statusClass(order.status)">
                          {{ translateStatus(order.status) }}
                        </b-badge>
                      </p>
                      <p>{{ howLong(order.createdAt) }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </FeathersVuexFind>
          </div>
        </vue-custom-scrollbar>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { mapState, mapActions, mapGetters } from "vuex";
import {
  getActiveBranch,
  getAccessToken,
  getActiveCompany,
} from "@/helpers/storage";
import { query, getUser } from "@/helpers/queries";
import { orderStatus } from "@/helpers/translateEnums";
import moment from "moment";
import NoImage from "@/assets/img/noimage.png";
import SoundAlert from "@/assets/audio/alerta-caixa.mp3";
import { print } from "@/helpers/print";

export default {
  name: "sidebar",
  components: {
    vueCustomScrollbar,
  },
  created() {
    const branchId = getActiveBranch();
    this.activeBranch = branchId;

    this.audio.addEventListener("ended", this.controlAudio);
  },
  data() {
    return {
      activeBranch: "",
      play: false,
      audio: new Audio(SoundAlert),
      queried: new Set(),
      queryScheduled: {
        status: {
          $nin: [8, 16, 32],
        },
        "scheduledOrder.scheduled": true,
      },
      hasScheduledOrders: false,
    };
  },
  computed: {
    ...mapState(["logo", "showSidebar"]),
    ...mapGetters({
      selectedOrder: "getSelectedOrder",
      enums: "getEnums",
      autoPrinted: "getAutoPrinted",
    }),
    searchQuery: () => query(),
    feathers() {
      return this.$FeathersVuex.api;
    },
    accessToken: () => getAccessToken(),
    numOrderStatus() {
      return this.enums.OrderStatusEnum;
    },
    branch() {
      return this.feathers.Branch.getFromStore(this.activeBranch);
    },
    company() {
      return this.feathers.Company.getFromStore(getActiveCompany());
    },
  },
  methods: {
    ...mapActions(["setOrder", "clearOrder", "setAutoPrinted"]),
    set(id) {
      if (id === this.selectedOrder) {
        this.clearOrder();
      } else {
        this.setOrder(id);
      }
    },
    user(id, totemUser) {
      const _user = this.feathers.User.getFromStore(id);
      if (totemUser) return _user;
      if (_user) {
        return _user;
      } else {
        if (!this.queried.has(id)) {
          this.queried.add(id);

          getUser(this.feathers, this.accessToken, id);
        }
      }
    },
    howLong(time) {
      return moment(time).format('DD/MM/YYYY HH:mm:ss');
    },
    sortDesc(items) {
      return this.$options.filters.sortDesc(items);
    },
    translateStatus(status) {
      return orderStatus(this, status);
    },
    orders(items) {
      const showOrder = (order) => {
        const online = order.paymentMethod.kind === "online";
        let result = !online;

        if (online && order.paid) {
          if (order.mp) {
            result = true;
          }

          if (order.onlinePayment && order.onlinePayment.pagseguro && order.paid) {
            result = true;
          }
          
          if (process.env.VUE_APP_TITLE != "Edumenu"){
            if(order.onlinePayment && order.onlinePayment.pagarme && order.paid){
              result = true;
            }
          }
        }

        return result;
      };

      const context = this;
      const result = this.sortDesc(
        items.filter(
          (item) =>
            moment(moment(item.createdAt)).isAfter(
              moment().subtract(16, "hours")
            ) &&
            item.status !== this.numOrderStatus.Cancelled &&
            showOrder(item) &&
            !(item.scheduledOrder && item.scheduledOrder.scheduled)
        )
      );

      let shouldPlay = false;
      let pendingIds = [];

      result.forEach((item) => {
        if (item.status === this.numOrderStatus.PendingApproval) {
          shouldPlay = true;
          pendingIds.push(item._id);

          // imprimindo automaticamente
          const user = this.feathers.User.getFromStore(item.customer);
          const company = context.company;
          const branch = context.branch;
          const enums = context.enums;

          if ((user || item.locationType === 8) && branch.automaticPrinting) {
            let wasPrinted = false;

            context.autoPrinted.forEach((id) => {
              if (id === item._id) wasPrinted = true;
            });

            if (!wasPrinted) {
              if (item.paymentMethod.kind !== "online") {
                context.setAutoPrinted(item._id);
                print(context, enums, item, company, branch, user);
              } else {
                if (
                  item.paid &&
                  ((item.mp && item.mp.status === "approved") ||
                    (item.onlinePayment &&
                      item.onlinePayment.pagseguro &&
                      item.onlinePayment.pagseguro.status.status === 3))
                ) {
                  context.setAutoPrinted(item._id);

                  print(context, enums, item, company, branch, user);
                }
              }
            }
          }
        }
      });

      if (pendingIds.length) {
        this.setOrder(pendingIds[pendingIds.length - 1]);
        this.playAudio();
      } else {
        this.stopAudio();
      }

      return result;
    },
    ordersScheduled(items) {
      const showOrder = (order) => {
        const online = order.paymentMethod.kind === "online";
        let result = !online;

        if (online && order.paid) {
          if (order.mp) {
            result = true;
          }

          if (order.onlinePayment && order.onlinePayment.pagseguro) {
            result = true;
          }
          if (process.env.VUE_APP_TITLE != "Edumenu"){
            if(order.onlinePayment && order.onlinePayment.pagarme){
              result = true;
            }else{
              result = true;
            }
          }
        }

        return result;
      };


      const result = this.sortDesc(
        items.filter(
          (item) =>
            item.status !== this.numOrderStatus.Cancelled && 
            // showOrder(item) &&
            item.company == getActiveCompany() &&
            item.branch == getActiveBranch()
        )
      );

      let pendingIds = [];

      result.forEach((item) => {
        if(item.status === this.numOrderStatus.PendingApproval) {  
          pendingIds.push(item._id);
        }
      });

      if (result.length > 0){
        this.hasScheduledOrders = true;
        // setTimeout(() => this.playAudio(), 5000);
      }else { 
        this.hasScheduledOrders = false; 
        this.stopAudio();
      }

      if (pendingIds.length) {
        setTimeout(() => this.playAudio(), 5000);
      } else {
        this.stopAudio();
      }

      this.$forceUpdate();

      return result;
    },
    photo(user) {
      if (!user) return NoImage;

      return user.photo || NoImage;
    },
    playAudio() {
      this.play = true;
      this.audio.currentTime = 0;
      this.audio.play();
    },
    stopAudio() {
      this.play = false;
      this.audio.pause();
      this.audio.currentTime = 0;
    },
    controlAudio() {
      if (this.play) this.playAudio();
      else this.stopAudio();
    },
    statusClass(status) {
      return this.$options.filters.orderClass(status, this.numOrderStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: $sidebar-width;
  background-color: #fff;
  box-shadow: $shadow;
  padding-top: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: width 200ms linear;
  z-index: 999;

  .scroll-area {
    height: calc(100vh - 120px);
  }

  @media (max-width: 1150px) {
    width: 0;
  }

  &.active {
    width: $sidebar-width;
  }

  &-logo {
    max-width: 180px;
    align-self: center;
  }

  &-menu {
    padding-left: 1.5rem;
  }

  &-link {
    color: $text-color;
    flex: 1;

    &:hover,
    &.active {
      color: $accent-color;
    }

    &::before {
      content: "";
      background-color: $accent-color;
      position: absolute;
      left: calc(0px - #{$sidebar-width});
      height: 80px;
      width: $sidebar-width;
      opacity: 0.1;
      transition: left 400ms ease;
    }

    &:hover::before,
    &.active::before {
      left: 0;
    }
  }

  &-icon {
    font-size: 1.5rem;
    margin-right: 5px;

    &-small {
      font-size: 1rem;
    }
  }

  &-sublink {
    padding-left: 20px;
    color: $text-color;
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
    }

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    &:hover {
      color: $accent-color;
    }
  }

  div {
    overflow: hidden;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
  }

  .loading-user {
    display: flex;
    align-items: center;
  }

  .user-name {
    font-weight: 500;
  }

  .user-info {
    display: flex;
    flex-direction: column;
  }

  .sidebar-item {
    height: 80px;
    display: flex;
    align-items: center;
  }

  .order-number {
    font-size: 0.7rem;
  }

  .order-status {
    font-weight: 300;
  }

  .user-photo {
    @extend %circle-image;
  }
}
</style>
